import { Paper } from "@mui/material";
import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Typography from "@mui/material/Typography";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { Timestamp } from "@firebase/firestore";
import CustomListItem from "./CustomListItem/CustomListItem";
import ApartmentIcon from "@mui/icons-material/Apartment";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import GradeIcon from "@mui/icons-material/Grade";
import DescriptionIcon from "@mui/icons-material/Description";
import { Grid } from "@mui/material";

function JobOfferDescription({ jobOffer }) {
  const {
    dateTill,
    description,
    jobProvider,
    jobProviderPhone,
    location,
    logo,
    name,
    reward,
  } = jobOffer;
  const dateObj = new Timestamp(
    dateTill.seconds,
    dateTill.nanoseconds
  ).toDate();
  const lastChanceDate = `${dateObj.toLocaleDateString().replace(/[ ]/g, "")}`;
  return (
    <Paper elevation={3} sx={{ width: "100%", padding: "60px 80px" }}>
      <List>
        <ListItem
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap-reverse",
          }}
        >
          <Typography sx={{ fontSize: "3rem", fontWeight: 500 }}>
            {name}
          </Typography>
          <ListItemAvatar>
            <img
              src={logo}
              alt={"logo_img"}
              style={{ maxWidth: "400px", height: "auto" }}
            />
          </ListItemAvatar>
        </ListItem>
        <Divider />
        <Grid container>
          <Grid item xs={12} xl={6}>
            <CustomListItem
              text={"Prácu ponúka"}
              emphasizedInfoAfterText={jobProvider}
              icon={<ApartmentIcon />}
            />
          </Grid>
          <Grid item xs={12} xl={6}>
            <CustomListItem
              emphasizedInfoAfterText={jobProviderPhone}
              icon={<LocalPhoneIcon />}
            />
          </Grid>
          <Grid item xs={12} xl={6}>
            <CustomListItem
              text={"Nahlásiť sa treba na"}
              emphasizedInfoAfterText={location}
              icon={<LocationOnIcon />}
            />
          </Grid>
          <Grid item xs={12} xl={6}>
            <CustomListItem
              text={"Nahlásiť sa je možné do"}
              emphasizedInfoAfterText={lastChanceDate}
              icon={<DateRangeIcon />}
            />
          </Grid>
        </Grid>
        <CustomListItem
          sx={{
            mb: 1
          }}
          emphasizedInfoAfterText={"Odmena"}
          icon={<GradeIcon />}
        />
        <Typography
          paragraph
          sx={{
            fontSize: "1.8rem",
            textAlign: "justify",
            ml: 4,
            mr: 4,
            mb: 0,
            padding: "0 25px",
          }}
        >
          {reward}
        </Typography>
        <CustomListItem
          emphasizedInfoAfterText={"Popis práce"}
          icon={<DescriptionIcon />}
        />
        <Paper
          sx={{ ml: 4, mr: 4, boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)" }}
          elevation={2}
        >
          <Typography
            paragraph
            sx={{
              fontSize: "1.6rem",
              textAlign: "justify",
              padding: "40px",
            }}
          >
            {description}
          </Typography>
        </Paper>
      </List>
    </Paper>
  );
}

export default JobOfferDescription;
